import { storage } from '../utils'
import { performFetch } from './utils'
import { browserHistory } from 'react-router'

function setRavenUserDetails(data) {
    const userContext = {}

    if (data.uuid) {
        userContext.id = data.uuid
    }

    if (data.email) {
        userContext.email = data.email
    }

    if (data.crew) {
        userContext.crew = data.crew.uuid
    }

    Raven && Raven.setUserContext(userContext)
}

export function signUp(data, onSuccess) {
    return performFetch({
        type: 'SIGN_UP',
        data,
        onSuccess: (data) => {
            if (data.token) {
                storage.setItem('authToken', data.token)
            }

            setRavenUserDetails(data)

            onSuccess && onSuccess(data)

            return { type: 'SIGN_UP_SUCCESS', data }
        },
    })
}

export function signIn(data) {
    return performFetch({
        type: 'SIGN_IN',
        data,
        onSuccess: (data) => {
            if (data.token) {
                storage.setItem('authToken', data.token)
            }

            setRavenUserDetails(data)

            browserHistory.push('/')

            return { type: 'SIGN_IN_SUCCESS', data }
        },
    })
}

export function signOut() {
    storage.removeItem('authToken')
    storage.removeItem('impersonationToken')

    setRavenUserDetails({})

    return { type: 'SIGN_OUT' }
}

export function activate(uuid, token) {
    return performFetch({
        type: 'ACTIVATE',
        urlData: { uuid, token },
    })
}

export function resendActivationLink(uuid) {
    return performFetch({
        type: 'RESEND_ACTIVATION_LINK',
        method: 'POST',
        urlData: { uuid },
    })
}

export function authenticate() {
    let token = storage.getItem('authToken')

    if (storage.getItem('impersonationToken')) {
        token = storage.getItem('impersonationToken')
    }

    if (token) {
        const data = { token }

        return performFetch({
            type: 'AUTHENTICATE',
            data,
            onSuccess: (data) => {
                if (! data.contract) {
                    browserHistory.push('/onboarding-instructions')
                }

                setRavenUserDetails(data)

                return { type: 'AUTHENTICATE_SUCCESS', data }
            },
            onError: () => {
                storage.removeItem('authToken')
                storage.removeItem('impersonationToken')
                browserHistory.push('/sign-in')

                setRavenUserDetails({})

                return { type: 'AUTHENTICATE_ERROR' }
            },
        })
    }

    // else:
    browserHistory.push('/sign-in')
    return { type: 'AUTHENTICATE_ERROR' }
}

export function forgotPassword(data) {
    return performFetch({
        type: 'FORGOT_PASSWORD',
        data,
    })
}

export function forgotPasswordTryAgain() {
    return { type: 'FORGOT_PASSWORD_TRY_AGAIN' }
}

export function validateResetPasswordToken(uuid, token) {
    return performFetch({
        type: 'VALIDATE_RESET_TOKEN',
        urlData: { uuid, token },
    })
}

export function setPassword(uuid, token, data) {
    return performFetch({
        type: 'SET_PASSWORD',
        urlData: { uuid, token },
        data,
    })
}



// WEBPACK FOOTER //
// ./app/actions/account.js